import {
  REACT_APP_CONFIG_BUCKET,
  REACT_APP_DEFAULT_RESOURCES_DOMAIN,
  REACT_APP_REPLACE_RESOURCES_DOMAIN,
} from '../constants/envs';

export const replaceDomain = (urlSource: string): string => {
  if (REACT_APP_DEFAULT_RESOURCES_DOMAIN !== REACT_APP_REPLACE_RESOURCES_DOMAIN) {
    const url = new URL(urlSource);

    url.hostname = url.hostname.replace(
      `.${REACT_APP_DEFAULT_RESOURCES_DOMAIN}`,
      `.${REACT_APP_REPLACE_RESOURCES_DOMAIN}`,
    );

    return url.href;
  }

  return urlSource;
};

export const replaceLogoDomain = (urlSource?: string): string => {
  if (urlSource) {
    try {
      const url = new URL(urlSource);

      url.hostname = REACT_APP_CONFIG_BUCKET;

      return url.href;
    } catch {
      return '';
    }
  }

  return '';
};

export const getChannelUrl = (basePath: string, name: string): string => `https://${basePath}/${name}`;
